export const makeSelectSummary = (state: AppState) => state.dashboardReducer.summary;

export const makeSelectTodoList = (state: AppState) => state.dashboardReducer.todoList;
